import { createSelector } from 'reselect'

import { getUserIdentity } from '~/redux-modules/identity'
import { FictivStateType } from '../fictivStateType'

export const DFMMessageTableSelector = createSelector(
    getUserIdentity,
    (state: FictivStateType) => state.dfmMessages,
    (identity, dfmMessages) => {
        return {
            isDFMfeedbackMessageadmin: identity.isDfmFeedbackEditor,
            dfmMessages,
        }
    },
)
